module.exports = __webpack_public_path__ + "static/media/banner-bg.734fc1b8.webp";